import { Outlet } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { HouseholdProvider } from "@/contexts/HouseholdContext";
import { I18nProvider } from "@/contexts/I18nContext";

/**
 * Universal-link landing for invite deep-links. Renders without chrome while
 * auth + household state is inspected and the user is routed per
 * [[specs/new-user-onboarding-and-join-flow]] sub-flows A–D.
 */
export function JoinLayout() {
  return (
    <AuthProvider>
      <HouseholdProvider>
        <I18nProvider>
          <div className="min-h-screen bg-gray-50 dark:bg-gray-950 text-gray-900 dark:text-gray-100">
            <Outlet />
          </div>
        </I18nProvider>
      </HouseholdProvider>
    </AuthProvider>
  );
}
